import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Invitation.tsx.esbuild-plugin-windicss.css';
import 'elab/material/material';
import 'elab/material/material.css';
import { memo, useCallback, useState } from 'preact/compat';
import { useTenantUsersWithoutCurrentUser } from '../data/tenantUsers';
import { i18n } from '../i18n';
import { nameAndEmail } from '../utils';
import { SubmitButton } from './SubmitButton';
const Section = ({
  caption,
  children
}: {
  caption: string;
  children: any;
}) => <section>
    <h4 data-text={caption} class="mb-2">
      {caption}
    </h4>
    {children}
  </section>;
export const EmailInvitation = memo(({
  disabled,
  invite
}: {
  disabled?: boolean;
  invite: (emails: readonly string[]) => unknown;
}) => {
  const inviteSingle = useCallback((email: string) => invite([email]), [invite]);
  return <Section caption={i18n.sharing.inviteGuest}>
      <form class="flex" onSubmit={event => {
      event.preventDefault();
      const email = event.currentTarget.email as HTMLInputElement;
      const emailValue = email.value.trim();
      if (emailValue) {
        inviteSingle(emailValue);
        email.value = '';
      }
    }}>
        <div class="mui-textfield flex-auto pt-0">
          <input type="email" name="email" disabled={disabled} required placeholder="xxx@example.com" />
        </div>
        <SubmitButton label={i18n.sharing.invite} disabled={disabled} style={{
        fontSize: 'inherit',
        marginLeft: '8px'
      }} />
      </form>
    </Section>;
});
export const TenantUsersInvitation = memo(({
  emailsExclude,
  disabled,
  invite
}: {
  emailsExclude: readonly string[];
  disabled?: boolean;
  invite: (emails: readonly string[]) => unknown;
}) => {
  const [emails, setEmails] = useState<string[]>([]);
  const tenantUsers = useTenantUsersWithoutCurrentUser();
  if (!tenantUsers) {
    return null;
  }
  return <Section caption={i18n.sharing.inviteTenantMember}>
        <form class="flex" onSubmit={event => {
      event.preventDefault();
      if (emails.length !== 0) {
        invite(emails);
        setEmails([]);
      }
    }}>
          <div class="elab flex-auto !min-h-2em !pt-0 mb-5 leading-tight" style="--elab-color: var(--primary-color)" onChange={e => setEmails((e as unknown as CustomEvent<{
        values: string[];
      }>).detail.values)}>
            <ul>
              {tenantUsers.filter(option => !emailsExclude.includes(option.email)).map(user => <li key={user.email} data-value={user.email} data-selected={emails.includes(user.email) ? '' : undefined}>
                    {nameAndEmail(user)}
                  </li>)}
            </ul>
            <div class="px-0.5em">▾</div>
          </div>
          <SubmitButton label={i18n.sharing.invite} disabled={disabled} style={{
        fontSize: 'inherit',
        marginLeft: '8px'
      }} />
        </form>
      </Section>;
});